import { render } from "./AutoLogout.vue?vue&type=template&id=b753a884"
import script from "./AutoLogout.vue?vue&type=script&lang=ts"
export * from "./AutoLogout.vue?vue&type=script&lang=ts"
script.render = render

export default script